import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiTableModule } from '@snelstart/ui-table';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import { FeatureTaxDividendListComponent } from "./tax-dividend-list/feature-tax-dividend-list.component";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule, FeatureTaxDividendListComponent],
  declarations: [],
  exports: [FeatureTaxDividendListComponent],
})
export class FeatureTaxDividendListModule {}
